module.exports = __webpack_public_path__ + "img/iphone-frame@2x.396108b7.png";